module.exports = "/_next/static/images/3vG-111c0634f3ad4072125ce0b15863fb03.png";